import includes from 'lodash/includes'
import { OrderPaymentStatusEnum } from '@ztechapps/common.contract'

/**
 * An order still owes money only while it is Unpaid or Partially Paid — Fully Paid, Over Paid and Not Receivable are
 * not outstanding. Drives the store order's `isStillNeedsPayment` and gates `isPostShipmentPayable`.
 */
export const isPaymentOutstanding = (paymentStatus: OrderPaymentStatusEnum): boolean =>
  includes([OrderPaymentStatusEnum.partiallyPaid, OrderPaymentStatusEnum.unpaid], paymentStatus)
